/* eslint-disable sonarjs/no-duplicate-string */

/**
 * This map is used to map Ionic icon names to Remix Icon names.
 * This map will be used in the Icon component to determine which Remix Icon to use once we turn the
 * Rebrand Feature Flag on.
 *
 * View https://docs.google.com/spreadsheets/d/1U6hjWiK1T2rhpSXA656mfmtg5mbPOWWRnvhD3r1SW5Y/edit?gid=0#gid=0 for the source of our mapping
 */
export const DEPRECATED_IONIC_ICON_TO_REMIX_ICON_NAME_MAP: Record<
  string,
  string
> = {
  'add-circle-outline': 'add-circle-line',
  'add-circle': 'add-circle-fill',
  'add-outline': 'add-line',
  'alarm-outline': 'alarm-line',
  'albums-outline': 'multi-image-line',
  'alert-circle-outline': 'error-warning-line',
  'alert-circle': 'error-warning-fill',
  'analytics-outline': 'line-chart-line',
  analytics: 'line-chart-line',
  apps: 'apps-2-line',
  'apps-outline': 'apps-2-line',
  'arrow-back': 'arrow-left-line',
  'arrow-down-outline': 'arrow-down-line',
  'arrow-forward': 'arrow-right-line',
  'arrow-ne': 'arrow-right-up-line',
  'arrow-right': 'arrow-right-s-line',
  'arrow-up-outline': 'arrow-up-line',
  'arrow-up-right-box-outline': 'external-link-line',
  'arrow-up-right-box': 'external-link-line',
  'arrow-up-right': 'arrow-right-up-line',
  'bag-handle-outline': 'shopping-bag-4-line',
  'bag-handle': 'shopping-bag-4-line',
  'bag-outline': 'shopping-bag-4-line',
  bag: 'shopping-bag-4-line',
  'ban-outline': 'prohibited-line',
  'beaker-outline': 'flask-line',
  'book-outline': 'book-open-line',
  book: 'book-open-line',
  'briefcase-outline': 'briefcase-2-line',
  briefcase: 'briefcase-2-line',
  'browsers-outline': 'window-line',
  'brush-outline': 'brush-line',
  'build-filled': 'tools-line',
  'business-outline': 'building-4-line',
  calculator: 'calculator-line',
  calendar: 'calendar-line',
  'calendar-clear-outline': 'calendar-line',
  'calendar-clear-sharp': 'calendar-line',
  'calendar-number-outline': 'calendar-line',
  'calendar-outline': 'calendar-line',
  call: 'phone-line',
  'call-outline': 'phone-line',
  'card-outline': 'bank-card-line',
  card: 'bank-card-line',
  'cart-sharp': 'shopping-cart-2-line',
  'cart-outline': 'shopping-cart-2-line',
  'cash-outline': 'cash-line',
  cash: 'cash-line',
  cellular: 'gg-cellular-line',
  'cellular-outline': 'gg-cellular-line',
  'chatbox-ellipses-outline': 'message-2-line',
  'chatbox-outline': 'chat-4-line',
  'chatbubble-ellipses-outline': 'message-2-line',
  'chatbubbles-outline': 'question-answer-line',
  checkbox: 'checkbox-fill',
  'checkbox-partial': 'checkbox-indeterminate-line',
  'checkmark-circle-grey': 'checkbox-circle-line',
  'checkmark-circle-outline': 'checkbox-circle-line',
  'checkmark-circle-sharp': 'checkbox-circle-fill',
  'checkmark-circle': 'checkbox-circle-fill',
  'checkmark-done-outline': 'check-double-line',
  'checkmark-done': 'check-double-line',
  'checkmark-outline': 'check-line',
  'checkmark-sharp': 'check-line',
  'chevron-back-outline': 'arrow-left-s-line',
  'chevron-back': 'arrow-left-s-line',
  'chevron-down-outline': 'arrow-down-s-line',
  'chevron-down-sharp': 'arrow-down-s-line',
  'chevron-down': 'arrow-down-s-line',
  'chevron-forward': 'arrow-right-s-line',
  'chevron-up': 'arrow-up-s-line',
  'client-outline': 'contacts-book-line',
  'clipboard-outline': 'clipboard-line',
  close: 'close-line',
  'close-circle-outline': 'close-circle-line',
  'close-circle': 'close-circle-fill',
  'close-outline': 'close-line',
  'cloud-upload-outline': 'upload-cloud-2-line',
  'color-palette-outline': 'palette-line',
  'color-wand-outline': 'magic-line',
  'color-wand-sharp': 'magic-line',
  'contrast-outline': 'contrast-line',
  'copy-sharp': 'file-copy-line',
  'create-outline': 'edit-box-line',
  'cube-outline': 'box-3-line',
  cube: 'box-3-line',
  'cut-outline': 'scissors-cut-line',
  'desktop-outline': 'mac-line',
  'diamond-sharp': 'vip-diamond-line',
  'document-text-outline': 'file-text-line',
  'document-text': 'file-text-line',
  'dollar-circle': 'cash-line',
  'dual-ellipsis-vertical': 'draggable',
  'ellipsis-horizontal': 'more-line',
  'ellipsis-vertical': 'more-2-line',
  'eye-off-sharp': 'eye-off-line',
  'eye-outline': 'eye-line',
  'eye-sharp': 'eye-line',
  'eyedrop-outline': 'dropper-line',
  facebook: 'facebook-circle-fill',
  filter: 'filter-3-line',
  'flag-outline': 'flag-line',
  'flash-fill': 'flashlight-fill',
  flash: 'flashlight-line',
  'flask-outline': 'flask-line',
  'flower-outline': 'flower-line',
  'genius-loans': 'hand-coin-line',
  'gift-outline': 'gift-line',
  'git-network': 'git-fork-line',
  'glasses-outline': 'glasses-2-line',
  'globe-outline': 'globe-line',
  globe: 'globe-line',
  'golf-outline': 'flag-line',
  'happy-outline': 'emotion-happy-line',
  'headset-outline': 'headphone-line',
  'help-circle-outline': 'question-line',
  'hourglass-outline': 'hourglass-2-line',
  'images-outline': 'multi-image-line',
  'info-outline': 'information-2-line',
  info: 'information-2-line',
  'information-circle': 'information-2-line',
  library: 'book-shelf-line',
  'link-outline': 'link-m',
  'location-outline': 'map-pin-2-line',
  'lock-closed-outline': 'lock-line',
  'log-out-outline': 'logout-box-r-line',
  'mail-outline': 'mail-line',
  'mail-unread-outline': 'mail-unread-line',
  mail: 'mail-line',
  'megaphone-outline': 'megaphone-line',
  menu: 'menu-line',
  moon: 'moon-line',
  'newspaper-outline': 'newspaper-line',
  'notifications-circle-outline': 'notification-badge-line',
  'notifications-outline-wide': 'notification-2-line',
  'notifications-outline': 'notification-2-line',
  open: 'external-link-line',
  'open-outline': 'external-link-line',
  'paper-plane': 'send-plane-2-line',
  'paper-plane-outline': 'send-plane-2-line',
  'pencil-outline': 'pencil-line',
  'pencil-sharp': 'pencil-line',
  'people-circle': 'group-2-line',
  'people-outline': 'group-line',
  people: 'group-line',
  'person-circle-outline': 'account-circle-line',
  'person-circle': 'account-circle-line',
  'person-off': 'user-minus-line',
  'person-outline': 'user-line',
  person: 'user-line',
  'phone-portrait-outline': 'smartphone-line',
  'pie-chart': 'pie-chart-2-line',
  play: 'play-large-line',
  'play-circle-outline': 'play-large-line',
  'play-circle': 'play-large-line',
  'power-outline': 'shut-down-line',
  power: 'shut-down-line',
  'pricetag-outline': 'price-tag-line',
  pricetag: 'price-tag-line',
  product: 'gg-bottle-pump-line',
  'product-outline': 'gg-bottle-pump-line',
  'reader-outline': 'article-line',
  reader: 'article-line',
  'receipt-outline': 'receipt-line',
  receipt: 'receipt-line',
  refresh: 'reset-right-line',
  'remove-sharp': 'subtract-line',
  remove: 'subtract-line',
  'ribbon-outline': 'award-line',
  'rocket-outline': 'rocket-2-line',
  'rose-outline': 'flower-line',
  'sad-outline': 'emotion-sad-line',
  sales: 'receipt-line',
  'scan-circle': 'gg-scan-line',
  search: 'search-line',
  'send-sharp': 'send-plane-2-line',
  'settings-outline': 'settings-3-line',
  settings: 'settings-3-line',
  'shapes-outline': 'shapes-line',
  shapes: 'shapes-line',
  'shield-checkmark-outline': 'shield-check-line',
  'shield-half-outline': 'shield-line',
  'shield-half': 'shield-line',
  'shield-outline': 'shield-line',
  shield: 'shield-line',
  'six-dots': 'draggable',
  'sparkles-outline': 'sparkling-line',
  sparkles: 'sparkling-line',
  'square-outline': 'checkbox-blank-line',
  'star-half': 'star-half-fill',
  'star-outline': 'star-line',
  star: 'star-fill',
  'store-front-outline': 'store-3-line',
  'store-front': 'store-3-line',
  'sunny-outline': 'sun-line',
  sunny: 'sun-line',
  'swap-horizontal': 'arrow-left-right-line',
  'sync-outline': 'loop-right-line',
  sync: 'loop-right-line',
  'ticket-outline': 'ticket-2-line',
  'time-outline': 'time-line',
  time: 'time-line',
  'trash-outline': 'delete-bin-line',
  trash: 'delete-bin-line',
  'trending-up-graph': 'line-chart-line',
  'trending-up': 'line-chart-line',
  umbrella: 'umbrella-line',
  'wallet-outline': 'wallet-line',
  'warning-outline': 'alert-line',
  warning: 'alert-fill',
  'web-link': 'link-m',
  wifi: 'wifi-line',
};
